import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

const cardWrapperStyles = ({ theme }: Theme) => css`
  label: container;

  margin-bottom: ${theme.spacings.mega};
`

const topContentStyles = ({ theme }: Theme) => css`
  label: top-content;

  display: flex;
  flex-direction: column;

  width: 100%;

  overflow: hidden;

  margin-bottom: ${theme.spacings.bit};

  text-transform: capitalize;
`

export const CardWrapper = styled('div')(cardWrapperStyles)
export const TopContent = styled('div')(topContentStyles)
